import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

/**
 * Modal type enum for label operations
 */
export enum ModalType {
	ADD = 'add',
	REMOVE = 'remove',
	UPDATE = 'update'
}

/**
 * Shared modal button and text constants
 */
export const SAVE_BUTTON_TEXT = 'Save';
export const CANCEL_BUTTON_TEXT = 'Cancel';

/**
 * Modal action titles mapped to modal types
 */
const MODAL_ACTION_TITLES: Record<ModalType, string> = {
	[ModalType.ADD]: 'Add label',
	[ModalType.REMOVE]: 'Remove label',
	[ModalType.UPDATE]: 'Update label'
};

/**
 * Common modal descriptions
 */
export const MODAL_DESCRIPTIONS: Record<ModalType, string> = {
	[ModalType.ADD]:
		"Select the label key and value to add. Labels will only be added if they aren't already applied to the test. You can add multiple labels before saving.",
	[ModalType.UPDATE]:
		'Select the label to update and the new value. You can update multiple labels before saving.',
	[ModalType.REMOVE]: 'Select the label to remove. You can remove multiple labels before saving.'
};

/**
 * Generate modal title based on modal type and number of tests
 */
export const getModalTitle = (modalType: ModalType, testRows: IWebSdkTest[]): string => {
	const actionTitle = MODAL_ACTION_TITLES[modalType];

	if (!testRows || testRows.length === 0) {
		return actionTitle;
	}

	if (testRows.length === 1) {
		const testRow = testRows[0];
		const testName =
			testRow?.testName || (testRow as { testDisplayName?: string })?.testDisplayName;
		let action = 'for';
		if (modalType === ModalType.ADD) {
			action = 'to';
		} else if (modalType === ModalType.REMOVE) {
			action = 'from';
		}
		return testName ? `${actionTitle} ${action} ${testName}` : actionTitle;
	}

	let action = 'for';
	if (modalType === ModalType.ADD) {
		action = 'to';
	} else if (modalType === ModalType.REMOVE) {
		action = 'from';
	}
	return `${actionTitle} ${action} ${testRows.length} tests`;
};
